/**
 * Indexer Module
 *
 * Provides secure, validated access to the indexer API with:
 * - Input validation
 * - Rate limiting
 * - Circuit breaker protection
 * - Request proxying through Vercel
 */

// Client functions for making requests
export {
  indexerFetch,
  fetchPooledAPY,
  fetchPooledAverageAPY,
  fetchIsolatedAPY,
  fetchUserHistory,
  fetchReferralLeaderboard,
  isExpensivePath,
} from './client'

// Validation utilities
export {
  validateChainId,
  validateAddress,
  validatePath,
  extractAndValidatePathParams,
  VALID_CHAIN_IDS,
  EXPENSIVE_PATHS,
} from './validation'

// Circuit breaker
export {
  getIndexerCircuitBreaker,
  withCircuitBreaker,
  CircuitBreaker,
} from './circuit-breaker'
export type { CircuitBreakerConfig, CircuitBreakerState, CircuitState } from './circuit-breaker'

// Rate limiting
export { checkRateLimit, getRateLimitStatus } from './rate-limiter'
export type { RateLimitConfig } from './rate-limiter'

// Errors
export {
  IndexerError,
  InvalidChainIdError,
  InvalidAddressError,
  InvalidPathError,
  RateLimitError,
  CircuitBreakerOpenError,
  IndexerTimeoutError,
  IndexerUnavailableError,
} from './errors'
